import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import LocationFieldRowTitles from "./location-field-row-titles"
import LocationFieldRows from "./location-field-rows"

const LocationTables = (props) => {
  const {id, fields} = props.location
  const name = props.locations[id].name
  let style = {}
  if (props.isMultiLocation) {
    if (props.index === 0) {
      style.borderTopLeftRadius = "0"
      style.borderTopRightRadius = "0"
    } else {
      style.marginTop = "20px"
    }
  } else {
    if (props.dateIndex === 0) {
      style.borderTopLeftRadius = "0"
      style.borderTopRightRadius = "0"
    }
  }

  return (
    <div style={style} className="location-timetable">
      <h4 className="text-center">{props.header || name}</h4>
      <LocationFieldRowTitles fields={fields} />
      <LocationFieldRows 
        id={id} fields={fields} date={props.date} isSdAdmin={props.isSdAdmin}
        onEventClicked={props.onEventClicked} onNewEvent={props.onNewEvent}
      />
      <div className="clearfix" />
    </div>
  )
}

LocationTables.propTypes = {
  isMultiLocation: PropTypes.bool,
  dateIndex: PropTypes.number,
  index: PropTypes.number,
  date: PropTypes.string.isRequired,
  header: PropTypes.string,
  location: PropTypes.object,
  locations: PropTypes.object,
  isSdAdmin: PropTypes.bool,
  onEventClicked: PropTypes.func.isRequired,
  onNewEvent: PropTypes.func.isRequired
}

const mapStateToProps = ({entities: {locations}}) => ({locations})

export default connect(mapStateToProps)(LocationTables)
